import { DisplayLanguageType } from '@/domain/value_objects/language/displayLanguageType'

export const getHeatMapOptions = (categories: string[], isLightMode: boolean, displayLanguage: DisplayLanguageType) => {
  return {
    theme: {
      mode: isLightMode ? 'light' : 'dark'
    },
    chart: {
      animations: {},
      background: isLightMode ? '#fff' : '#383838',
      foreColor: isLightMode ? '#1F2937' : '#EDF2F7',
      type: 'heatmap',
      toolbar: {
        show: true,
        tools: {
          download: false
        }
      }
    },
    plotOptions: {
      chart: {
        type: 'heatmap',
        toolbar: {
          show: false,
          tools: {
            download: false,
            selection: false
          }
        },
        zoom: {
          enabled: false
        }
      },
      heatmap: {
        enableShades: false,
        shadeIntensity: 0,
        colorScale: {
          ranges: [
            {
              from: -65536,
              to: 0,
              color: isLightMode ? '#EBEDF0' : '#575757',
              name: displayLanguage === 'Japanese' ? '提出なし' : 'zero'
            },
            {
              from: 1,
              to: 5,
              color: isLightMode ? '#9BE9A8' : '#78b082',
              name: displayLanguage === 'Japanese' ? '低' : 'low',
              foreColor: '#000'
            },
            {
              from: 6,
              to: 10,
              color: isLightMode ? '#3cb35d' : '#3cb35d',
              name: displayLanguage === 'Japanese' ? '中' : 'medium',
              foreColor: isLightMode ? '#101010' : '#202020'
            },
            {
              from: 11,
              to: 65536,
              color: isLightMode ? '#216E39' : '#216E39',
              name: displayLanguage === 'Japanese' ? '高' : 'high',
              foreColor: isLightMode ? '#eeeeee' : '#dddddd'
            }
          ]
        }
      }
    },
    stroke: {
      width: 3,
      colors: [isLightMode ? '#fff' : '#383838']
    },
    grid: {
      xaxis: {
        lines: {
          show: false
        }
      },
      yaxis: {
        lines: {
          show: false
        }
      }
    },
    xaxis: {
      position: 'top',
      categories: categories,
      labels: {
        show: true,
        rotate: 0,
        showDuplicates: false,
        hideOverlappingLabels: true,
        minHeight: 40,
        style: {
          fontSize: '10px',
          colors: isLightMode ? '#1F2937' : '#dfdfdf'
        },
        offsetY: 7
      },
      axisBorder: {
        show: false
      },
      axisTicks: {
        show: false
      },
      tooltip: {
        enabled: false
      }
    },
    yaxis: {
      reversed: true,
      labels: {
        show: true,
        style: {
          colors: isLightMode ? '#1F2937' : '#dfdfdf'
        }
      },
      axisBorder: {
        show: false
      },
      axisTicks: {
        show: false
      }
    },
    dataLabels: {
      style: {
        fontSize: '10px',
        fontWeight: 'bold',
        colors: [isLightMode ? '#232A3B' : '#dfdfdf']
      },
      formatter: (
        val: string,
        opt: {
          w: { globals: { labels: { [x: string]: string } } }
          dataPointIndex: string | number
        }
      ) => (val == '0' ? '' : Number(val) > 99 ? '' : val)
    },
    title: {
      align: 'center',
      text: displayLanguage === 'Japanese' ? 'ACヒートマップ' : 'HeatMap of AC',
      style: {
        fontSize: '20px',
        color: isLightMode ? '#263238' : '#dfdfdf'
      }
    },
    states: {
      active: {
        filter: {
          type: 'none'
        }
      },
      hover: {
        filter: {}
      }
    },
    tooltip: {
      enabled: true,
      custom: (opts: {
        ctx: {
          w: {
            config: {
              series: {
                [x: string]: {
                  data: {
                    [x: string]: {
                      [x: string]: any
                      description: any
                    }
                  }
                }
              }
            }
          }
        }
        seriesIndex: string | number
        dataPointIndex: string | number
        series: { [x: string]: { [x: string]: any } }
      }) => {
        const desc = opts.ctx.w.config.series[opts.seriesIndex].data[opts.dataPointIndex].x
        const value = opts.series[opts.seriesIndex][opts.dataPointIndex]
        return (
          "<ul style='padding:2px 10px 2px 10px; background-color:#1A1A1A; color:#dfdfdf; font-size:16px;'><li>" +
          desc +
          ': <b>' +
          value +
          '</b> AC</li></ul>'
        )
      }
    }
  }
}
